function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:#262626}\r\n        "));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_2",
  d: "M63.641-2580H57v-2h7.3a7.953 7.953 0 0 0-.664 2zm3.194-5H57v-2h18v1.3a7.923 7.923 0 0 0-3.5-.8 7.943 7.943 0 0 0-4.664 1.5zm8.165-5H57v-2h18v2z",
  className: "cls-2",
  "data-name": "Subtraction 2",
  transform: "translate(-57 2593)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_4",
  d: "M64-2578a7.008 7.008 0 0 1-7-7 7.008 7.008 0 0 1 7-7 7.008 7.008 0 0 1 7 7 7.008 7.008 0 0 1-7 7zm0-5a1 1 0 0 0-1 1 1 1 0 0 0 1 1 1 1 0 0 0 1-1 1 1 0 0 0-1-1zm-1-7v6h2v-6z",
  className: "cls-2",
  "data-name": "Subtraction 4",
  transform: "translate(-49 2600)"
});
var SvgIssueSummary = function SvgIssueSummary(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_RM_Issue",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIssueSummary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/issue_summary.afb7a6fa.svg";
export { ForwardRef as ReactComponent };